import PropTypes from 'prop-types';
import React from 'react';

import './button.css';

const ButtonComponent = ({
    className,
    disabled,
    iconClassName,
    iconSrc,
    onClick,
    children,
    ...props
}) => {

    if (disabled) {
        onClick = function () {};
    }

    const icon = iconSrc && (
        <img
            className="iconClassName iconClose"
            draggable={false}
            src={iconSrc}
        />
    );

    return (
        <span
            className={`outlinedButton ${className}`}
            role="button"
            onClick={onClick}
            {...props}
        >
            {icon}
            <div className="contentBtn">{children}</div>
        </span>
    );
};

ButtonComponent.propTypes = {
    children: PropTypes.node,
    className: PropTypes.string,
    disabled: PropTypes.bool,
    iconClassName: PropTypes.string,
    iconSrc: PropTypes.string,
    onClick: PropTypes.func
};

export default ButtonComponent;
